// extracted by mini-css-extract-plugin
module.exports = {"shadow":"modal_shadow__2hqSU"};